import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {connect} from 'react-redux';

import Footer from "../components/navigation/Footer";
import NavbarUser2 from '../components/navigation/NavbarUser2';

const LayoutUser = (props ) => {
    return (
        <div>
            <NavbarUser2/>
            <ToastContainer autoClose={5000}/>
            {props.children}
            <Footer/>
        </div>
    )
}

const mapStateToProps = state => ({

})

export default connect(mapStateToProps, {

})(LayoutUser)
